import * as tslib_1 from "tslib";
/** @jsx jsx */

import { jsx, Global, css } from "@emotion/core";
import * as React from "react";
import toaster from "toasted-notes";
import { Alert } from "./Alert";
import { useTheme, ThemeProvider } from "./Theme/Providers";
var toastStyles = css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  .Toaster__message-wrapper {\n    padding: 8px;\n    text-align: left;\n  }\n"], ["\n  .Toaster__message-wrapper {\n    padding: 8px;\n    text-align: left;\n  }\n"])));
/**
 * We export toast as a hook because it allows us to consume
 * the current theme context that it's in and pass that
 * onto our render function
 */

export function useToast() {
  var theme = useTheme();

  function notify(_a) {
    var position = _a.position,
        duration = _a.duration,
        render = _a.render,
        title = _a.title,
        subtitle = _a.subtitle,
        intent = _a.intent;
    var options = {
      position: position,
      duration: duration
    };

    if (render) {
      return toaster.notify(function (_a) {
        var onClose = _a.onClose,
            id = _a.id;
        return jsx(React.Fragment, null, jsx(Global, {
          styles: toastStyles
        }), jsx(ThemeProvider, {
          theme: theme
        }, render({
          onClose: onClose,
          id: id
        })));
      }, options);
    }

    toaster.notify(function (_a) {
      var onClose = _a.onClose,
          id = _a.id;
      return jsx(React.Fragment, null, jsx(Global, {
        styles: toastStyles
      }), jsx(ThemeProvider, {
        theme: theme
      }, jsx(Alert, {
        id: String(id),
        title: title,
        component: "div",
        elevation: "md",
        subtitle: subtitle,
        intent: intent,
        onRequestClose: onClose
      })));
    }, options);
  }

  return notify;
}
var templateObject_1;